module.exports = __webpack_public_path__ + "img/banner-en.45c48ed3.png";